<template>
    <div>
        <div class="login-container">
            <div class="row">
                <div class="col-md-12">
                    <div class="text-center m-b-md">
                        <img src="@/assets/images/logo.png"/>
                    </div>
                    <div class="hpanel">
                        <div class="panel-body">
                            <form @submit.prevent="login">
                                <p class="text-danger m-b-sm text-center" v-if="errorMessage">{{errorMessage}}</p>
                                <div class="form-group">
                                    <input style="display:none" type="text" name="fakeusernameremembered"/>
                                    <input style="display:none" type="password" name="fakepasswordremembered"/>
                                    <label class="control-label" for="wz-user">Usuario</label>
                                    <custom-input type="text" placeholder="Usuario"
                                                  :field="$v.username"
                                                  :focus="true"
                                                  tipo="text"
                                                  title="Usuario"
                                                  name="wz-user"
                                                  id="wz-user"/>
                                </div>
                                <div class="form-group">
                                    <label class="control-label" for="wz-pwd">Contraseña</label>
                                    <custom-input type="password"
                                                  :field="$v.password"
                                                  tipo="password"
                                                  title="Contraseña" placeholder="********"
                                                  name="wz-pwd" id="wz-pwd"/>
                                </div>
                                <invisible-recaptcha :callback="callbackCaptcha"
                                                     :sitekey="reCaptchaKey" type="submit"
                                                     class="btn btn-primary btn-block">
                                    Iniciar sesión
                                </invisible-recaptcha>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CustomInput from './common/CustomInput.vue'
    import {required} from 'vuelidate/lib/validators'
    import {AUTH_REQUEST} from "../store/actions/auth";
    import {DASHBOARD} from "../router/routes";

    export default {
        components: {
            CustomInput
        },
        data() {
            return {
                reCaptchaKey: process.env.RECAPTCHA_API_KEY,
                username: null,
                password: null,
                errorMessage: null
            }
        },
        validations: {
            username: {required},
            password: {required},
        },
        methods: {
            login: function () {
                this.$v.$touch();
                if (this.$v.$error) return;
                const self = this;
                self.errorMessage = null;
                self.$store.dispatch(AUTH_REQUEST, self.$data).then(() => {
                    self.$router.push(DASHBOARD.route);
                }).catch((err) => {
                    self.errorMessage = err.message;
                });
            },
            callbackCaptcha: function () {
                this.login();
            }
        },
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Login.vue